module.exports = __webpack_public_path__ + "static/media/docx.93886c5a.png";